import orthancAPI from '@ohif/core/src/utils/orthancAPI';

import { REPORT_ATTACHMENT_ID } from '../../AZmed/Data/reportSeries';

// Fetches the report attached to a series: null when there is none, throws on failure.
export const fetchReport = async seriesInstanceUID => {
  // Resolve the Orthanc id of the series
  const seriesOrthancId = await orthancAPI.lookupOrthancID(seriesInstanceUID);
  if (!seriesOrthancId) {
    throw new Error(`Could not resolve series ${seriesInstanceUID}`);
  }

  // Fetch its report attachment, 404 meaning no report
  const response = await orthancAPI.fetchSeriesAttachmentResponse(
    seriesOrthancId,
    REPORT_ATTACHMENT_ID
  );
  if (response.status === 404) {
    return null;
  }

  if (!response.ok) {
    throw new Error(`Failed to fetch series attachment: ${response.status}`);
  }

  return response.json();
};
